<template>
    <VueFlatPickr
        class="flatpickr"
        :name="name"
        :config="config"
    ></VueFlatPickr>
</template>
<script setup lang="ts">
import VueFlatPickr from "vue-flatpickr-component";
import { German } from "flatpickr/dist/l10n/de";

interface Props {
    name: string;
}

const props = defineProps<Props>();

const config = {
    locale: German,
    dateFormat: "d.m.Y",
    altInput: true,
    altFormat: "d.m.Y",
    time_24hr: true,
    disable: [
        function (date: { getDay: () => number }) {
            // return true to disable
            return date.getDay() === 0 || date.getDay() === 6;
        },
    ],
};
</script>
